import { DEFAULT_LIST_ID, DEFAULT_LIST_TYPE, DEFAULT_VIEW_ID } from '../defaults';
import { ListItem } from '../types/Lists';

export const defaultList: ListItem = {
    listId: DEFAULT_LIST_ID,
    type: DEFAULT_LIST_TYPE,
    name: 'All Contacts',
    viewId: DEFAULT_VIEW_ID,
    isFavorite: true,
    isArchived: false,
};
